import { Component, inject, Input } from '@angular/core';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MenuActions } from '../../../states/menu_actions';
import { BlogPostInterface } from '@interfaces/blog/bog-post-interface';
import { LanguageService } from '@core/services/language/language.service';

@Component({
  selector: 'ln-blog-card',
  imports: [LnImageFrameComponent, TranslocoPipe],
  templateUrl: './blog-card.component.html',
  styleUrl: './blog-card.component.css',
})
export class BlogCardComponent {
  @Input({ required: true }) blogPostInterface!: BlogPostInterface;
  private locale = inject(LanguageService);
  menuAction = inject(MenuActions);
  formatRawDate(date: string): string {
    return new Date(date).toLocaleString(this.locale.getCurrentLanguageLocale(), {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }
  navigateToBlogDetails(): void {
    this.menuAction.navigateToBogDetails(this.blogPostInterface.id.toString());
  }
}
